module.exports = __webpack_public_path__ + "img/UserSysteamOtherInterests.015e8a6d.svg";